module.exports = __webpack_public_path__ + "static/media/imgStrategy.91e48d94.svg";